/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetRouteByFactoryID,
    GetFarmerDetailsByFactoryIDRouteID,
    GetFarmerCropPlotDetailsByFarmerID,
    RemoveFarmerCropPlotDetails,
    AddFarmerCropPlotDetails,
    UpdateFarmerCropPlotDetails,
    GetProductLifeCyclePikingDetailsByProductID,
    AddFarmerPlotDetails,
    UpdateFarmerPlotDetails,
    RomveFarmerPlotDetails,
    GetFarmerCollectionCenterDetailsByFarmerID,
    GetProductCategoties,
    GetProductDetails,
    GetAllProductVarietyByProductID,
    GetProductsByFactoryIDProductcatogeryID,
    CheckGeoLocationByFarmerPlotMappingID,
    SendEarlyFinishCropRequest
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupIDV2', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRouteByFactoryID(factoryID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}

async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetNewFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetFarmerCropPlotDetailsByFarmerID(farmerID, operationEntityID, isSeasonal) {
    const response = await CommonGet('/api/FarmerCropPlot/GetFarmerCropPlotDetailsByFarmerID', 'farmerID=' + parseInt(farmerID)
        + '&operationEntityID=' + parseInt(operationEntityID) + '&isSeasonal=' + isSeasonal);
    return response.data;
}

async function RemoveFarmerCropPlotDetails(data) {
    var values = {
        farmerPlotCropMappingID: parseInt(data.farmerPlotCropMappingID),
        cropID: parseInt(data.cropID),
        cropVarietyID: parseInt(data.cropVarietyID),
        farmerID: parseInt(data.farmerID),
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/FarmerCropPlot/RemoveFarmerCropPlotDetails', null, values);
    return response;
}

async function AddFarmerCropPlotDetails(data, cropDetails, pikingsDetails, isManualPickings) {
    var values = {
        farmerID: cropDetails.farmerID,
        cropID: data.cropID,
        farmerPlotMappingID: cropDetails.farmerPlotMappingID,
        cropVarietyID: data.productVarietyID,
        startDate: data.date,
        expectedStartDate: data.startDate,
        expectedEndDate: data.endDate,
        yield: parseFloat(data.yield),
        noOfPikings: parseInt(data.noOfPikings),
        cultivationPercentage: parseFloat(data.cultivationPercentage),
        cropPikings: pikingsDetails,
        IsCropLifeCycle: isManualPickings,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/FarmerCropPlot/AddFarmerCropPlotDetails', null, values);
    return response;
}

async function UpdateFarmerCropPlotDetails(data, cropDetails, pikingsDetails) {
    var values = {
        farmerPlotCropMappingID: cropDetails.farmerPlotCropMappingID,
        farmerID: cropDetails.farmerID,
        cropID: data.cropID,
        farmerPlotMappingID: cropDetails.farmerPlotMappingID,
        cropVarietyID: data.productVarietyID,
        startDate: data.date,
        expectedStartDate: data.startDate,
        expectedEndDate: data.endDate,
        yield: parseFloat(data.yield),
        noOfPikings: parseInt(data.noOfPikings),
        cultivationPercentage: parseFloat(data.cultivationPercentage),
        cropPikings: pikingsDetails,
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/FarmerCropPlot/UpdateFarmerCropPlotDetails', null, values);
    return response;
}

async function GetProductLifeCyclePikingDetailsByProductID(productID, productVarietyID, plotTypeID) {
    const response = await CommonGet('/api/ProductLifeCycle/GetProductLifeCyclePikingDetailsByProductID', 'productID=' + parseInt(productID) + '&productVarietyID=' + parseInt(productVarietyID) + '&plotTypeID=' + parseInt(plotTypeID));
    return response.data;
}

async function AddFarmerPlotDetails(data, farmerID) {
    var values = {
        farmerID: parseInt(farmerID),
        acres: parseFloat(data.acres),
        perches: parseFloat(data.perches),
        collectionCenterID: parseFloat(data.collectionCenterID),
        plotCategoryID: parseInt(data.plotCategoryID),
        plotMethodID: parseInt(data.plotMethodID),
        plotName: data.plotName,
        plotNo: data.plotNo,
        plotTypeID: parseInt(data.plotTypeID),
        unitID: parseInt(data.unitID),
        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/FarmerCropPlot/SaveFarmerPlotDetails', null, values);
    return response;
}

async function UpdateFarmerPlotDetails(data, cropDetails) {
    var values = {
        farmerPlotMappingID: parseInt(cropDetails.farmerPlotMappingID),
        acres: parseFloat(data.acres),
        perches: parseFloat(data.perches),
        collectionCenterID: parseFloat(data.collectionCenterID),
        plotCategoryID: parseInt(data.plotCategoryID),
        plotMethodID: parseInt(data.plotMethodID),
        plotName: data.plotName,
        plotNo: data.plotNo,
        plotTypeID: parseInt(data.plotTypeID),
        unitID: parseInt(data.unitID),
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/FarmerCropPlot/UpdateFarmerPlotDetails', null, values);
    return response;
}

async function RomveFarmerPlotDetails(data) {
    var values = {
        farmerPlotMappingID: parseInt(data.farmerPlotMappingID),
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/FarmerCropPlot/RemoveFarmerPlotDetails', null, values);
    return response;
}

async function GetFarmerCollectionCenterDetailsByFarmerID(farmerID) {
    const response = await CommonGet('/api/Farmer/GetFarmerCollectionCenterDetailsByFarmerID', 'farmerID=' + parseInt(farmerID));
    return response.data;
}

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + productID);
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + parseInt(factoryID) + '&productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function CheckGeoLocationByFarmerPlotMappingID(farmerPlotMappingID) {
    const response = await CommonGet('/api/FarmerCropPlot/CheckGeoLocationByFarmerPlotMappingID', 'farmerPlotMappingID=' + parseInt(farmerPlotMappingID));
    return response.data;
}

async function SendEarlyFinishCropRequest(data, groupID, operationEntityID) {
    var values = {
        farmerID: data.farmerID,
        requestReason: data.requestReason,
        statusID: 1, // 0 - active status, 1 - pending status
        farmerPlotCropMappingID: data.farmerPlotCropMappingID,
        farmerPlotMappingID: data.farmerPlotMappingID,
        groupID: groupID,
        operationEntityID: operationEntityID,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/FarmerCropPlot/SendEarlyFinishCropRequest', null, values);
    return response;
}